import { RouterView } from "@/routes/RouterView.js";
const Training = _ =>
    import(/* webpackChunkName: "js/split/Tutor", webpackPreload: true */
    "@/components/views/home/advisor/company/partials/Training");
const AddTrainingPlan = _ =>
    import(/* webpackChunkName: "js/split/Tutor", webpackPreload: true */
    "@/components/views/home/advisor/company/partials/partialsTraining/AddTrainingPlan");

export default {
    path: "/planes-de-capacitacion/",
    component: RouterView,
    children: [
        {
            path: "index",
            component: Training,
            name: "Training",
            meta: {
                auth: true
            }
        },
        {
            path: "nuevo",
            component: AddTrainingPlan,
            name: "AddTrainingPlan",
            meta: {
                auth: true
            }
        }
    ]
};
